<template>
  <div class="shrink-0 text-xs leading-4 px-2 py-px rounded-md whitespace-nowrap bg-white text-grey-800 border border-solid border-grey-400">
    Ad
  </div>
</template>
